export default __webpack_public_path__ + "static/media/loading-icon.b892ee6b.svg";